import PageBody from "../PageBody";
import NotificationTypeDetail from "../components/pages/notifications/NotificationTypeDetail";

const NotificationTypeDetailPage = () => {
  return (
    <PageBody>
      <NotificationTypeDetail />
    </PageBody>
  );
};

export default NotificationTypeDetailPage;
